export const fetchMyCourses = async ({ BeURL }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            return { success: false, message: "Backend URL not provided or invalid", orders: [] }
        }

        const res = await fetch(`${BeURL}/fetch-orders`, { credentials: "include" })
        const data = await res.json()

        if (!data?.success) {
            return { success: false, message: data?.message || "Failed to fetch orders", orders: [] }
        }

        return { success: true, orders: Array.isArray(data.orders) ? data.orders : [] }
    } catch (error) {
        console.error("Error fetching orders:", error)
        return { success: false, message: "An error occurred while fetching orders", orders: [] }
    }
}
